import { FilterLinesIcon } from '@langchain/untitled-ui-icons';

import { FilterDialogContent } from '@/components/FilterBar/FilterBar';
import { RunFilterCount } from '@/components/FilterBar/FilterCount';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/Popover';
import { Badge, Text } from '@/design-system';
import { cn } from '@/utils/tailwind';

export const FiltersDisplay = ({
  filter,
  traceFilter,
  treeFilter,
}: {
  filter?: string;
  traceFilter?: string;
  treeFilter?: string;
}) => {
  const filterExists =
    (filter && filter.trim() !== '') ||
    (traceFilter && traceFilter.trim() !== '') ||
    (treeFilter && treeFilter.trim() !== '');

  return (
    <div className="flex shrink-0 items-center text-xxs">
      <Popover>
        <PopoverTrigger asChild disabled={!filterExists}>
          <div
            className={cn(filterExists ? 'cursor-pointer' : 'cursor-normal')}
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            <Badge
              color="secondary"
              className={cn(
                filterExists
                  ? 'cursor-pointer hover:bg-quaternary'
                  : 'cursor-normal',
                'border-none bg-tertiary text-secondary'
              )}
              rounded="full"
              leftDecorator={FilterLinesIcon}
            >
              <>
                <Text variant="xs">Run filters</Text>
                <span className="rounded-full bg-tertiary px-1.5 text-xxs text-tertiary">
                  <RunFilterCount
                    filter={filter}
                    treeFilter={treeFilter}
                    traceFilter={traceFilter}
                  />
                </span>
              </>
            </Badge>
          </div>
        </PopoverTrigger>
        <PopoverContent
          className="w-auto min-w-[300px] overflow-hidden p-0 pb-3"
          side={traceFilter || treeFilter ? 'left' : 'bottom'}
        >
          <FilterDialogContent
            stats={undefined}
            value={{
              filter,
              traceFilter,
              treeFilter,
            }}
            onChange={() => {}}
            setFilterBarOpen={() => {}}
            showSaveFilters={false}
            readOnly={true}
          />
        </PopoverContent>
      </Popover>
    </div>
  );
};
